module.exports = __webpack_public_path__ + "static/img/img_logo_13.aa06d8b1.png";